const init = e => {
  // start custom slider
  function isMobile() {
    let windowWidth = window.innerWidth;
    if(windowWidth < 769) {
        return true
    } else {
        return false;
    }
  }

  const debounce = (f, delay) => {
    let timer = 0;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    }
  }

  const sliderReinitCallback = ([entry]) => {
    const flkty = Flickity.data(entry.target);
    if (flkty) flkty.resize();
  }

  const initCustomSlider = (slider) => {
    let args = slider.dataset.args;
    const mobileOnly = slider.dataset.mobileOnly;
    if(args) {
        args = JSON.parse(args);
    }
    if(mobileOnly == "true") {
        initMobileOnlySlider(slider, args);
    } else {
        let flickity = new theme.Slideshow(slider, args);
        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(slider);
    }
  }

  const customSliders = document.querySelectorAll('.custom-slider-js');

  if(customSliders.length) {
      customSliders.forEach(slider => {
          initCustomSlider(slider);
      })
  }

  const customDotsMove = document.querySelectorAll('.custom-slider_dots-move');

  if(customDotsMove.length) {
      customDotsMove.forEach(dots => {
          if ( dots.closest('.shopify-section').querySelector(".custom-slider_dots-location") ) {
              dots.closest('.shopify-section').querySelector(".custom-slider_dots-location").appendChild(dots.querySelector('.flickity-page-dots'));
          }
      })
  }

  const customLeftMove = document.querySelectorAll('.custom-slider_left-move');

  if(customLeftMove.length) {
    customLeftMove.forEach(left => {
      if ( left.closest('.shopify-section').querySelector(".custom-slider_left-location") ) {
          left.closest('.shopify-section').querySelector(".custom-slider_left-location").appendChild(left.querySelector('.flickity-previous'));
      }
    })
  }

  const customRightMove = document.querySelectorAll('.custom-slider_right-move');

  if(customRightMove.length) {
    customRightMove.forEach(right => {
        if ( right.closest('.shopify-section').querySelector(".custom-slider_right-location") ) {
          right.closest('.shopify-section').querySelector(".custom-slider_right-location").appendChild(right.querySelector('.flickity-next'));
        }
    })
  }
  // end custom slider

  // start header mobile search
  const searchBtn = document.querySelector('.search-btn');
  const mobileSearchBar = document.querySelector('.mob-search-bar');

  document.addEventListener('click', event => {
    if (event.target === searchBtn) {
        mobileSearchBar.classList.add('active-search');
    } else {
      if (!mobileSearchBar.contains(event.target) && !searchBtn?.contains(event.target)) {
        mobileSearchBar.classList.remove('active-search');
      }
    }
  });
  // end header mobile search

  // start upsell
  document.addEventListener('cart:ready', () => {
    
    const sliders = document.querySelectorAll('.js-cross-sell-slider');
    sliders.forEach(slider => {
      setTimeout(function() {
        initCustomSlider(slider);
      },400);
    })
    
    const atcBtns = document.querySelectorAll('.js-cross-sell-to-cart');
    atcBtns.forEach(btn => {
      btn.addEventListener('click', addToCart, false);
    })
  });
  // end upsell

  // start shipping cart drawer
  const shippingCalculatorBtn = document.querySelector('.shipping-calculator__heading');
  shippingCalculatorBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.target.classList.contains('active') ? e.target.classList.remove('active') : e.target.classList.add('active');
  });
  // end shipping cart drawer

  // start account
  const logout = document.querySelector('.logOut');
  const dataPopUpCartSuccess = document.querySelector('div[data-popup="cart-success"]');
  const overlay = document.querySelector('.overlay');
  const csPopup = document.querySelector('.cs-popup');
  const body = document.querySelector('body');
  const close = document.querySelectorAll('.popup-closer,.keep_shop,.cancel_button a');

  if ( logout ) {
    logout.addEventListener('click', (e) => {
      dataPopUpCartSuccess.classList.add('popup-active');
      overlay.classList.add('popup-active');
    });
  }

  overlay.addEventListener('click', (e) => {
    csPopup.classList.remove('popup-active');
    overlay.classList.remove('popup-active');
    body.classList.remove('popup-active');
  });

  close.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.target.closest('.cs-popup').classList.remove('popup-active');
      overlay.classList.remove('popup-active');
    });
  })
  // end account

  // start videos
  const videos = document.querySelectorAll('.video-btn');
  const videosPlayer = document.querySelectorAll('.video-player');

  if ( videos.length > 0 ) {
    videos.forEach(v => {
      v.addEventListener('click', (e) => {
        e.preventDefault();
        v.closest('.video-thumb').classList.add('active');

        if ( v.closest('.video-thumb').querySelector('video') ) {
          v.closest('.video-thumb').querySelector('video').play();
        }
      })
    })
  }

  if ( videosPlayer.length > 0 ) {
    videosPlayer.forEach(vp => {
      vp.addEventListener('click', (e) => {
        e.preventDefault();
        vp.closest('.video-thumb').classList.remove('active');

        if ( vp.closest('.video-thumb').querySelector('video') ) {
          vp.closest('.video-thumb').querySelector('video').pause();
          vp.closest('.video-thumb').querySelector('video').currentTime = 0;
        }
      })
    })
  }
  // end videos

  // start pdp readmore
  const desc = document.querySelector('.product-description > .rte');

  if ( desc ) {

    let maxHeight = parseInt(desc.offsetHeight) + parseInt(100);
    
    if ( desc.offsetHeight > 500 ) {
      
      desc.classList.add('with-readmore');
      desc.innerHTML += '<button class="readmore">Read More</button>';

      const readMoreBtn = document.querySelector('.readmore');

      if ( readMoreBtn ) {        
        readMoreBtn.addEventListener('click', () => {

          if (readMoreBtn.innerHTML === "Read More") {
            readMoreBtn.innerHTML = "Read Less";
            desc.style.paddingBottom = 30 + 'px';
            desc.style.maxHeight = maxHeight + 'px';
          } else {
            readMoreBtn.innerHTML = "Read More";
            desc.style.paddingBottom = '';
            desc.style.maxHeight = '';
          }

          desc.classList.toggle('with-readmore_expand');
        })
      }
    }
  }
  //end pdp readmore

  //multilevel menu
  const parent = document.querySelectorAll('.multilevel-parent');
  const thirdLevelParent = document.querySelectorAll('.multilevel-third');
  const thirdLevel = document.querySelectorAll('.mega-menu_third-level');
  const fourthLevel = document.querySelectorAll('.mega-menu_fourth-level');
  const fourthLevelParent = document.querySelectorAll('.multilevel-fourth');
  const images = document.querySelectorAll('.mega-menu_right .image');
  const megaMenuParentLinks = document.querySelectorAll('.megamenu-list .multilevel-parent');
  const megaMenuThirdLinks = document.querySelectorAll('.megamenu-list .multilevel-third');

  parent.forEach(item => {
      item.addEventListener('mouseover', () => {
          let parent = item.dataset.parent;
          let handle = item.dataset.handle;

          megaMenuParentLinks.forEach(links => {
              links.classList.remove('active');
          });

          item.classList.add('active');

          if ( images.length > 0 ) {
              images.forEach(image => {
                  image.classList.remove('active');
              });
          }

          if ( handle && !item.classList.contains('no-child') ) {
              if ( document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`) ) { 
                  document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`).classList.add('active');
              }
          }

          if ( thirdLevel.length > 0 ) {
              thirdLevel.forEach(thirdLevelItem => {
                  thirdLevelItem.classList.remove('active');
              })
          }

          if ( fourthLevel.length > 0 ) {
              fourthLevel.forEach(fourthLevelItem => {
                  fourthLevelItem.classList.remove('active');
              })
          }
              
          let thirdLevelSelector = document.querySelector(`.mega-menu_third-level[data-parent="${parent}"]`);

          if ( thirdLevelSelector ) {
              document.querySelector(`.mega-menu_third-level[data-parent="${parent}"]`).classList.add('active');
          }
      })
  });

  thirdLevelParent.forEach(thirdItem => {
      thirdItem.addEventListener('mouseover', () => {
          let parent = thirdItem.dataset.parent;
          let handle = thirdItem.dataset.handle;

          megaMenuThirdLinks.forEach(links => {
              links.classList.remove('active');
          });

          thirdItem.classList.add('active');

          if ( images.length > 0 ) {
              images.forEach(image => {
                  image.classList.remove('active');
              });
          }

          if ( handle ) {
              if ( document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`) ) { 
                  document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`).classList.add('active');
              }
          }

          if ( fourthLevel.length > 0 ) {
              fourthLevel.forEach(fourthLevelItem => {
                  fourthLevelItem.classList.remove('active');
              })
          }
              
          let fourthLevelSelector = document.querySelector(`.mega-menu_fourth-level[data-parent="${parent}"]`);

          if ( fourthLevelSelector ) {
              document.querySelector(`.mega-menu_fourth-level[data-parent="${parent}"]`).classList.add('active');
          }
      })
  });

  fourthLevelParent.forEach(fourthItem => {
      fourthItem.addEventListener('mouseover', () => {
          let handle = fourthItem.dataset.handle;

          if ( images.length > 0 ) {
              images.forEach(image => {
                  image.classList.remove('active');
              });
          }

          if ( handle ) {
              if ( document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`) ) { 
                  document.querySelector(`.mega-menu_right .image[data-collection="${handle}"]`).classList.add('active');
              }
          }
      })
  })
  
  const mainNav = document.querySelectorAll('.site-nav__link.site-nav__link--has-dropdown');

  mainNav.forEach(nav => {
    nav.addEventListener('mouseover', () => {
      let thisNav = nav.closest('.site-nav__details');
      thisNav.querySelector('.mega-menu_third-level')?.classList.add('active');

      parent.forEach(p => {
        p.classList.remove('active');
      });

      thirdLevel.forEach(thirdLevel => {
        thirdLevel.classList.remove('active');
      });

      images.forEach(image => {
        image.classList.remove('active');
      });
      
      thisNav.closest('.site-nav__details').querySelector('.image[data-collection="'+ thisNav.closest('.site-nav__details').querySelector('.mega-menu_third-level').dataset.handle +'"]')?.classList.add('active');
    })
  })
  // end megamenu

  // start mobile menu
  const NavDrawer = document.querySelector('#NavDrawer');
  const mobileNavParent = document.querySelectorAll('.mobile-nav__dropdown.parent');

  mobileNavParent.forEach(parent => {
    parent.addEventListener('click', (e) => {
      e.preventDefault();

      parent.closest('li.mobile-nav__item').classList.toggle('active');
      NavDrawer.classList.add('unscroll');
      NavDrawer.scrollTo(0,0);
    });
  })

  const mobileNavSeconddHeader = document.querySelectorAll('.mobile-nav__second-level > .drawer__header');

  mobileNavSeconddHeader.forEach(secondHeader => {
    secondHeader.addEventListener('click', (e) => {
      e.preventDefault();

      secondHeader.closest('li.mobile-nav__item').classList.remove('active');
      NavDrawer.classList.remove('unscroll');
    });
  })

  const mobileNavSecondLevel = document.querySelectorAll('.mobile-nav__second-level .second-nav__item > .mobile-nav__dropdown');

  mobileNavSecondLevel.forEach(secondLink => {

    secondLink.addEventListener('click', (e) => {
      e.preventDefault();

      secondLink.closest('li.second-nav__item').classList.toggle('active');
      secondLink.closest('.mobile-nav__second-level').classList.add('unscroll');
      secondLink.closest('.mobile-nav__second-level').scrollTo(0,0);
    });
  })

  const mobileNavThirdHeader = document.querySelectorAll('.mobile-nav__third-level > .drawer__header');

  mobileNavThirdHeader.forEach(thirdHeader => {
    thirdHeader.addEventListener('click', (e) => {
      e.preventDefault();

      thirdHeader.closest('li.second-nav__item').classList.remove('active');
      thirdHeader.closest('.mobile-nav__second-level').classList.remove('unscroll');
    });
  })

  const mobileNavThirdLink = document.querySelectorAll('.mobile-nav__third-level .thid-nav__item > .mobile-nav__dropdown');

  mobileNavThirdLink.forEach(thirdLink => {

    thirdLink.addEventListener('click', (e) => {
      e.preventDefault();

      thirdLink.closest('li.thid-nav__item').classList.toggle('active');
    });
  })
  // end mobile menu

  // start video div placeholder
  const videoDivPlaceholders = document.querySelectorAll('.video-div-placeholder');
  videoDivPlaceholders.forEach(placeholder => {
    const parent = placeholder.closest('.hero-slider');
    let activated = false;
    const handleActivation = (e) => {
      if (activated) return;
      activated = true;
      showVideoDivPlaceholder(placeholder);
      parent.removeEventListener('mouseover', handleActivation);
      parent.removeEventListener('touchstart', handleActivation);
    };
    parent.addEventListener('mouseover', handleActivation);
    parent.addEventListener('touchstart', handleActivation);
  })

  function showVideoDivPlaceholder(placeholder) {
    const template = document.getElementById(placeholder.dataset.templateId);
    if (template) {
      const clone = template.content.cloneNode(true);
      placeholder.innerHTML = "";
      placeholder.appendChild(clone);
    }
  }
  // end video div placeholder
};

document.addEventListener('DOMContentLoaded', init, false);


document.addEventListener('click', function(event) {
  // start filter in stock
  const filterTagAvailable = document.querySelector('[for="tagInput-filter.v.availability-1"]');
  
  if (event.target.classList.contains('collection-filter__item--stock') ) {
  
    if ( filterTagAvailable ) {
      
      filterTagAvailable.click();
    }
  }

  // start ajax push pagination
  if ( event.target.classList.contains('btn-paginate') ) {
    // window.history.pushState(window.location.host,"", event.target.getAttribute('href'));
  }
})

// start upsell add to cart
const addToCart = async e => {
  const self = e.target;
  const parent = self.closest('.cross-sell-product');
  const variants = parent.querySelector('select.product-variant-selector');
  const variantId = variants ? variants.options[variants.selectedIndex].value : self.dataset.id;


  let item = {
    'items': [{
      'id': JSON.parse(variantId),
      'quantity': 1
    }]
  };

  self.classList.add('btn--loading');
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(item),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await res.json();

    if (res.ok) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    }
    
  }
  catch (err) {
    console.log(err);
  }
  finally {
    self.classList.remove('btn--loading');
  }
}
// end upsell add to cart


(function(){
  const fetchToURL = async (url, settings, type = null) => {
      let response = await fetch(url, settings);
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      return type ? await response.text() : await response.json();
  };

  const timeout = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
  }

  const shopableLookbook = elem => {
      const triggers = elem.querySelectorAll('button[aria-controls]');
      const thumbnails = elem.querySelectorAll('figure[data-control]');
      const contents = elem.querySelectorAll('.product-info[data-control]');
      const messaging = elem.querySelector('.shoplook-header');

      const reset = () => {
          triggers.forEach(btn => {
              btn.classList.remove('active');
              btn.setAttribute('aria-selected', 'false');
          });

          thumbnails.forEach(e => e.classList.remove('active'));
          contents.forEach(e => e.classList.remove('active'));
          if (messaging) messaging.classList.remove('active');
      };

      const activateContent = e => {
          const self = e.target;
          const controlHandle = self.getAttribute('aria-controls');

          if (self.classList.contains('active')) {
              reset();
          } else {
              reset();

              let currentImage = [...thumbnails].find(e => e.getAttribute('data-control') === controlHandle);
              let currentContent = [...contents].find(e => e.getAttribute('data-control') === controlHandle);

              self.classList.add('active');
              currentImage.classList.add('active');
              currentContent.classList.add('active');
              if (messaging) messaging.classList.add('active');
          }
      };

      triggers.forEach(btn => {
          btn.addEventListener('click', activateContent, false);
      });

      reset();
  };

  const lookbooks = document.querySelectorAll('[data-shopable-lookbook]');
  lookbooks.forEach(shopableLookbook);


  const addToCart = elem => {
      elem.addEventListener('click', e => {
          const self = e.target;
          const parent = self.closest('[data-parent]');
          const select = parent.querySelector('select');
          const variantId = select?.value ? select.value : parent.dataset.variantId;

          let data = {
              'items': [{
                  'id': variantId,
                  'quantity': 1
              }]
          };

          if (!variantId) return

          let settings = {
              method: 'POST',
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              }
          }

          self.classList.add('btn--loading');

          fetchToURL('/cart/add.js', settings)
              .then(async data => {
                  self.classList.remove('btn--loading');
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                      detail: {
                          product: data
                      }
                  }));

                  self.textContent = 'Added!';
                  await timeout(2000);
                  // self.textContent = self.dataset.text;
              })
              .catch(async error => {
                  console.error('There has been a problem with your fetch operation:', error);
                  self.classList.remove('btn--loading');
                  self.classList.add('error');
                  self.textContent = 'Not added!';
                  await timeout(2000);
                  self.textContent = self.dataset.text;
                  self.classList.remove('error');
              });
      });
  };

  const addToCartButtons = document.querySelectorAll('.js-add-to-cart');
  addToCartButtons.forEach(addToCart);
})();

// New Shoppable lookbook with sliders
// Added 25/02/2022
// Steadlane Francis
const DOMReady = e => {

  const timeout = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Initialize slider to parent container

  const shopableLookbooks = document.querySelector('.shopable-lookbooks');
  let slider;
  if (shopableLookbooks) {
    slider = tns({
      container: '.shopable-lookbooks',
      loop: false,
      slideBy: 'page',
      mouseDrag: true,
      swipeAngle: false,
      arrowKeys: true,
      navPosition: 'bottom',
      gutter: 10
    });
  }

  // Initialize each lookbook item, modals and display default product
  const initLookbook = elem => {
    const parent = elem.closest('.shopable-lookbooks-section');
    const triggers = elem.querySelectorAll('button[aria-controls]');

    let modals = parent.querySelectorAll('.modal-container .product-info[data-modal-control]');
    const openModal = e => {
      const self = e.target;
      const handle = self.getAttribute('aria-controls');
      let current = [...modals].find(e => e.getAttribute('data-modal-control') === handle);

      triggers.forEach(t => t.classList.remove('active'));
      modals.forEach(p => p.classList.remove('active'));

      self.classList.add('active');
      current.classList.add('active');
      document.documentElement.classList.add('no-scroll');
    }

    let closeModalBtns = parent.querySelectorAll('.js-close-modal');
    const closeModal = e => {
      const self = e.target;
      const parent = self.closest('.product-info');

      parent.classList.remove('active');
      document.documentElement.classList.remove('no-scroll');
    }

    let products = elem.querySelectorAll('.product-info[data-control]');
    const displayProduct = e => {
      const self = e.target;
      const handle = self.getAttribute('aria-controls');
      let current = [...products].find(e => e.getAttribute('data-control') === handle);

      triggers.forEach(t => t.classList.remove('active'));
      products.forEach(p => p.classList.remove('active'));

      self.classList.add('active');
      current.classList.add('active');
    }

    // Apply listeners only to certain media queries on page load
    let mql = window.matchMedia('(max-width: 959px)');
    if (mql.matches) {
      triggers.forEach(btn => {
        btn.addEventListener('click', openModal, false);
      });

      closeModalBtns.forEach(btn => {
        btn.addEventListener('click', closeModal, false);
      });

    } else {
      triggers.forEach(btn => {
        btn.addEventListener('click', displayProduct, false);
        if (btn.classList.contains('js-default')) btn.click();
      });
    }
  }

  const lookbooks = document.querySelectorAll('.js-shopable-lookbook .shopable-lookbooks-item');
  lookbooks.forEach(initLookbook);

  // Product add to cart
  const productAddToCart = async e => {
    e.preventDefault();
    const form = e.target;
    const elements = Array.from(form.elements);
    const singleVariant = elements.find(el => el.name === 'single-variant');
    const multipleVariant = elements.find(el => el.name === 'multiple-variants');
    const button = elements.find(el => el.type === 'submit');
    const modal = form.querySelector('.js-close-modal');

    let item = {
      'items': [{
        'id': singleVariant ? JSON.parse(singleVariant.value) : multipleVariant ? JSON.parse(multipleVariant.value) : null,
        'quantity': 1
      }]
    };

    // Add the product to cart
    try {
      button.classList.add('btn--loading');
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(item),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const data = await res.json();

      if (res.ok) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
    }
    catch (err) {
      console.log(err);
      button.classList.remove('btn--loading');
      if (modal) modal.click();
    }
    finally {
      button.classList.remove('btn--loading');
      if (modal) modal.click();
    }
  }
  const atcForms = document.querySelectorAll('.js-lookbook-form');
  atcForms.forEach(form => {
    form.addEventListener('submit', productAddToCart, false);
  });

  const activateMiniCart = async (e) => {
    console.log({e});
    
    const cartContainer = document.getElementById('crt');
    const headerCartCount = document.querySelector('.cart-count');
    
    try {
      const res = await fetch('/cart.js', {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const data = await res.json();
      if (res.ok) {
        // Update cart count in header
        headerCartCount.textContent = data.item_count;

        // Trigger class to open mini cart then close after a few seconds
        document.body.classList.add('cartOpen');
        await timeout(3000)
        document.body.classList.remove('cartOpen');
      }
    } catch (error) {
      console.log({ error });
    };

    try {
      const res = await fetch('/cart?view=mini');
      const data = await res.text();
      if (res.ok) {
        cartContainer.innerHTML = '';
        cartContainer.innerHTML = data;
        document.dispatchEvent(new CustomEvent('minicart:updated'))
      }
    } catch (error) {
      console.log({ error })
    };
  }
    
  const buildCart = async (e) => {
    const cartForm = document.getElementById('CartDrawerForm');
    const cartItemsEl = document.getElementById('inner-cart-contents');
    const cartTotalEl = cartForm.querySelector('.cartTotal .right strong');
    const cartUpsellEl = cartForm.querySelector('.cart-cross-sell-holder');

    try {
      const res = await fetch('/cart?view=ajax');
      const data = await res.text();
      
      if (res.ok) {
        const parser = new DOMParser;
        const doc = parser.parseFromString(data, 'text/html');
        const items = doc.querySelector('.cart__items');
        const discounts = doc.querySelector('.cart__discounts');
        const cartTotal = items.dataset.cartTotal;
        const upsell = doc.querySelector('.cart-cross-sell');

        // Update cart total
        if (cartTotalEl) {
          cartTotalEl.innerText = cartTotal;
        }

        // Update cart items
        cartItemsEl.innerHTML = '';
        cartItemsEl.append(items);

        // Update or add upsell slider
        if(cartUpsellEl && upsell) {
          cartUpsellEl.innerHTML = '';
          cartUpsellEl.append(upsell);
          initCrossSell(jQuery);
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));

      }
    } catch (error) {
      console.log(error)
    }
  }
  
  document.addEventListener('ajaxProduct:added', (e) => {
    if (theme.settings && theme.settings.cartType === 'drawer') {
      buildCart(e);
    } 
    
    if (theme.settings && theme.settings.cartType === 'hover') {
      activateMiniCart(e);
    }
  });
}

document.addEventListener('DOMContentLoaded', DOMReady, false);

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    productCard: '.product-slider-item',
    method: 'click',
    saveHistory: true,
    loader: true,
    scrollHistory: true
  });
});

document.addEventListener("DOMContentLoaded", function()  {
  const btnCalculateShipping = document.querySelector('.btnCalculateShipping');

  if ( btnCalculateShipping ) {

    btnCalculateShipping.addEventListener('click', () => {
      let postCode = document.querySelector('.txtPostcode').value;
      let productId = document.querySelector('#productId').value;
      let variantId = document.querySelector('#txtVariantID').value;
      let productWeight = document.querySelector('#txtBespokeVariantWeight').value;
      let productSku = document.querySelector('#productSku').value;
      let deliveryPartner = document.querySelector('.btnCalculateShipping').getAttribute('data-delivery-partner');
      let quantityElement = document.querySelector('.js-qty__num');
      let quantity = quantityElement ? parseInt(quantityElement.value) : 1;
      document.querySelector('#lblBespokeRate').innerHTML = "";

      if (!/^\d{4}$/.test(postCode)) {
        document.querySelector('#lblBespokeRate').innerHTML = "Please enter a valid 4-digit postcode.";
        document.querySelector('#lblBespokeRate').classList.add("shown");
        return;
      }

      let noDeliveryCodesElem = document.querySelector('#no-delivery-codes');
      let noDeliveryCodes = null;
      if (noDeliveryCodesElem) {
        noDeliveryCodes = JSON.parse(noDeliveryCodesElem.innerText);
      }
      if (noDeliveryCodes && noDeliveryCodes[variantId] && noDeliveryCodes[variantId].includes(postCode)) {
        document.querySelector('#lblBespokeRate').innerHTML = "Unfortunately your postcode is outside of our delivery zone for this item";
        document.querySelector('#lblBespokeRate').classList.add("shown");
        return;
      }

       let requestObj = {
        "rate": {
          "currency": "AUD",
          "destination": {
            "postal_code": postCode
          },
          "items": [
            {
              "fulfillment_service": "manual",
              "grams": productWeight,
              "name": "Short Sleeve T-Shirt",
              "price": 21999,
              "product_id": productId,
              "properties": null,
              "quantity": quantity,
              "requires_shipping": true,
              "sku": productSku,
              "taxable": true,
              "variant_id": variantId,
              "vendor": "Jamie D's Emporium"
            }
          ],
          "locale": "en"
        }
      };

      fetch(`https://it52mc9j39.ap-southeast-2.awsapprunner.com/carrier/unified`, {
        method: 'POST',
        body: JSON.stringify(requestObj),
        headers: {
          'Content-Type': 'application/json'
        },
        dataType: 'json',
        contentType: 'application/json',
        processData: false,
      })
      .then(response => {
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("404 - Not Found");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(response => {
        console.log(response);
        let hasRate = false;
        let output = '';
        response.rates.forEach(rate => {
          output += rate.service_name + ' - $' + Math.round(rate.total_price / 100) + '<br />\n';
          hasRate = true;
        })
        if (!hasRate) {
          output = 'No rates found';
        }

        document.querySelector('#lblBespokeRate').innerHTML = output;
        document.querySelector('#lblBespokeRate').classList.add("shown");
      })
      .catch(error => {
        console.log(error);
        document.querySelector('#lblBespokeRate').innerHTML = "Please contact our Customer Service team for a bespoke freight quote for this item to your postcode.";
        document.querySelector('#lblBespokeRate').classList.add("shown");
      });
    });
  }

  const btnCalculateShippingCart = document.querySelector('.shipping-calculator__calculate-btn')
  
  // Add Enter key event listeners to shipping calculator inputs
  const shippingInputs = document.querySelectorAll('.shipping-calculator__postcode-input, .shipping-calculator__state-select');
  
  shippingInputs.forEach(input => {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault(); // Prevent cart form submission
        input.blur();
        btnCalculateShippingCart.click();
      }
    });
  });
  
  btnCalculateShippingCart.addEventListener('click', async (e) => {
    e.preventDefault();

    let parent = e.target.closest('.shipping-calculator');
    let panel = parent.querySelector('.shipping-calculator__panel');
    let currentOutput = parent.querySelector('.shipping-calculator__output');

    currentOutput ? panel.removeChild(currentOutput) : '';

    let stateSelect = parent.querySelector('.shipping-calculator__state-select');
    let state = stateSelect.options[stateSelect.selectedIndex].value;
    let postcode = parent.querySelector('.shipping-calculator__postcode-input').value;

    // Create and show loading spinner
    let loadingSpinner = document.createElement('div');
    loadingSpinner.classList.add('shipping-calculator__output', 'shipping-calculator__loading');
    loadingSpinner.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; padding: 5px 0; margin-bottom: 15px;">
        <div style="border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; width: 20px; height: 20px; animation: spin 1s linear infinite; margin-right: 10px;"></div>
        <span style="font-size: 14px;">Calculating shipping rates...</span>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
    panel.append(loadingSpinner);

    let prepareURLString = `/cart/prepare_shipping_rates.json?`;
    let asyncURLString = `/cart/async_shipping_rates.json?`;

    let urlParams = new URLSearchParams;
    urlParams.append('shipping_address[zip]', postcode);
    urlParams.append('shipping_address[country]', 'Australia');
    urlParams.append('shipping_address[province]', state);

    let prepareURL = `${prepareURLString}${urlParams}`;
    let asyncURL = `${asyncURLString}${urlParams}`;

    try {
      // 1. Call to process calculating of shipping rates
      const prepare = await fetch(prepareURL, { method: 'POST' });

      if (!prepare.ok) {
          throw new Error(`HTTP error! status: ${prepare.status}`);
      }

      // 2. Get calculated shipping rates with retry logic
      let shippingRates = null;
      let attempts = 0;
      const maxAttempts = 5;

      while (attempts < maxAttempts && !shippingRates) {
        attempts++;
        console.log(`Attempt ${attempts} to fetch shipping rates`);
        
        const results = await fetch(asyncURL);
        const data = await results.json();

        // check if data is null
        if (data === null) {
          console.log(`Attempt ${attempts} returned null`);
          if (attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attempts * 500));
          }
        } else {
          shippingRates = data.shipping_rates;
        }
      }

      console.log({shippingRates, attempts})

      // Remove loading spinner
      panel.removeChild(loadingSpinner);

      let delivery = document.createElement('div');
      delivery.classList.add('shipping-calculator__output');
      delivery.innerHTML = '';

      if (shippingRates && shippingRates.length > 0) {
        let temp = '';

        shippingRates.forEach((elem, index) => {
          temp += `<p style="font-size: 14px; padding: 5px 0;">${elem.name}: $${elem.price}</p>`;
        })

        delivery.innerHTML = temp;
      } else {
        delivery.innerHTML = '<p style="font-size: 14px; padding: 5px 0;">Not available for delivery.</p>';
      }

      panel.append(delivery);

    } catch (err) {
        console.error(err);

        // Remove loading spinner
        if (panel.contains(loadingSpinner)) {
          panel.removeChild(loadingSpinner);
        }

        let delivery = document.createElement('div');
        delivery.classList.add('shipping-calculator__output');
        delivery.innerHTML = '<p style="font-size: 14px; padding: 5px 0;">Sorry, we were not able to calculate shipping rates.</p>';
        panel.append(delivery);
    } finally {

    }
  })
});

document.addEventListener("DOMContentLoaded", function()  {
  Shopify.CustomerAddress = {

    toggleForm: function(id) {
      var editEl = document.getElementById('EditAddress_'+id);
      editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
      return false;
    },

    toggleNewForm: function() {
      var el = document.getElementById('AddressOne');
      el.style.display = el.style.display == 'none' ? '' : 'none';
      return false;
    },
    destroy: function(id, confirm_msg) {
      if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
        Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
      }
    }
  }
  
  const CHANGEADDRESSES = document.querySelectorAll('.changeaddress');
  const EDITFORMCLASS = document.querySelectorAll('.editformClass');
  const CANCELFORM = document.querySelectorAll('.cancel_form');

  CHANGEADDRESSES.forEach(function (button) {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        
        if (this.classList.contains('active')) {
          EDITFORMCLASS.forEach(function (form) {
                form.style.display = 'none';
            });
            CHANGEADDRESSES.forEach(function (btn) {
                btn.classList.remove('active');
            });
        } else {
          CHANGEADDRESSES.forEach(function (btn) {
                btn.classList.remove('active');
            });
            this.classList.add('active');
            
            var x = this.closest('.editbuttonClass').dataset.id;
            
            EDITFORMCLASS.forEach(function (form) {
                form.style.display = 'none';
            });
            
            var targetForm = document.querySelector('.editformClass.' + x);
            if (targetForm) {
                targetForm.style.display = 'block';
                window.scrollTo({
                    top: targetForm.offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    });
  });

  CANCELFORM.forEach(function (button) {
      button.addEventListener('click', function () {
        EDITFORMCLASS.forEach(function (form) {
              form.style.display = 'none';
          });
      });
  });
});

// Load more items
class LoadMore extends HTMLElement {
  constructor(){
    super();

    this.action = this.dataset.action;
    this.baseUrl = this.dataset.url;
    this.totalPages = +this.dataset.totalPages;
    this.currentPage = +this.dataset.currentPage;
    this.gridTarget = document.querySelector(this.dataset.gridTarget);
    this.gridTargetClass = this.dataset.gridTarget;
    this.gridItemTargetClass = this.dataset.gridItemTarget;

    this.renderBtn();
  }

  renderBtn() {
    let showBtn = false;

    if(this.action === "next" && this.totalPages > this.currentPage) {
      showBtn = true;
    }

    if(this.action === "previous" && this.currentPage !== 1) {
      showBtn = true;
    }

    if(showBtn) {
      let btnHtml = `
        <div class="load-more-wrap text-center${this.action === "next" ? " load-more-next" : " load-more-previous"}">
          <button type="button" class="btn btn--small">Load ${this.action === "next" ? "More" : "Previous"}</button>
        </div>
      `;
      this.innerHTML = btnHtml;
      this.registerBtnEvtListener();
    }
  }

  registerBtnEvtListener() {
    const btn = this.querySelector('.btn');
    btn.addEventListener('click', (e) => {
      this.fetchItems(e.target);
    })

    /* Infinite scroll on next btn */
    const nextBtnWrap = this.querySelector('.load-more-next');
    if(nextBtnWrap) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(handleIntersect, options);

      observer.observe(nextBtnWrap);

      function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            btn.click()
          }
        });
      }
    }
  }

  getCurrentUrl() {
    let queryString = window.location.search;

    if(queryString) {
      const urlParams = new URLSearchParams(queryString);
      if(urlParams.has('page')) {
        queryString = queryString.replace(`page=${urlParams.get('page')}`, '[page]');
      }
      return this.baseUrl + queryString;
      
    } else {
      return this.baseUrl;
    }
  }

  async fetchItems(btn) {
    btn.classList.add('btn--loading');

    let currentUrl = this.getCurrentUrl();
    let newPage = this.currentPage;

    if(this.action === "next") {
      newPage = this.currentPage + 1;
    }

    if(this.action === "previous") {
      newPage = this.currentPage - 1;
    }

    if(currentUrl.includes('[page]')) {
      currentUrl = currentUrl.replace('[page]', 'page=' + newPage);
    } else if(currentUrl.includes('?')) {
      currentUrl = currentUrl +'&page='+newPage;
    } else {
      currentUrl = currentUrl +'?page='+newPage;
    }

    try {
      const res = await fetch(currentUrl);
      const text = await res.text();

      if (res.ok) {
        this.renderItems(text);
      }
    } catch (error) {
      console.log(error);
    } finally {
      if((this.action === "next" && newPage >= this.totalPages) || (this.action === "previous" && newPage <= 1)) {
        btn.remove();
      } else {
        btn.classList.remove('btn--loading');
      }
      this.updatePageCount(newPage);
      window.history.pushState({page: newPage}, "", currentUrl);
    }
  }

  updatePageCount(newPage) {
    this.currentPage = newPage;
    this.setAttribute('data-current-page', newPage);
  }

  parseProductHTML(text) {
    const html = document.createElement('div');
    html.innerHTML = text;

    return {
      items: html.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`)
    }
  }

  renderItems(text) {
    const markup = this.parseProductHTML(text);
    if(this.action === "next") {
      this.gridTarget.append(...markup.items);
    }
    if(this.action === "previous") {
      this.gridTarget.prepend(...markup.items);
    }

    if (window.AOS) { AOS.refreshHard() }

  }
}

if (!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore);
}
